import { Layout } from 'antd';
import { Route, Routes } from 'react-router-dom';
import TeamAdminContent from '../../components/Layout/TeamAdminContent';
import TeamAdminFooter from '../../components/Layout/TeamAdminFooter';
import TeamAdminHeader from '../../components/Layout/TeamAdminHeader';
import TeamAdminSider from '../../components/Layout/TeamAdminSider';
import PasswordOverlay from '../../components/PasswordOverlay';
import { usePasswordAuth } from '../../hooks/usePasswordAuth';
import Home from '../Home/Home';
import ListTeams from '../ListTeams/ListTeams';
import './App.css';
import ListChecker from '../ListChecker/ListChecker';

const App = () => {
  const { isAuthenticated, isLoading, authenticate } = usePasswordAuth();

  if (isLoading) {
    return null;
  }

  return (
    <>
      <PasswordOverlay 
        visible={!isAuthenticated} 
        onAuthenticate={authenticate}
      />
      <Layout>
        <TeamAdminSider />
        <Layout className='site-layout'>
          <TeamAdminHeader />
          <Routes>
            <Route path='/' element={<TeamAdminContent />}>
              <Route path='/' element={<Home />} />
              <Route path='teams' element={<ListTeams />} />
              <Route path='list-checker' element={<ListChecker />} />
              {/* 
              <Route path='list' element={<ListEvents />} />
              <Route path='view/:eventId' element={<> view event </>} />
              <Route path='rankings' element={<Rankings />} />
              <Route path='users' element={<ListUsers />} /> 
              */}
            </Route>
          </Routes>
          <TeamAdminFooter />
        </Layout>
      </Layout>
    </>
  );
};

export default App;
